import RoofSnapApiClient from './roofSnapApiClient';

const baseUrl = "sketchadminsketchorders";

class SketchAdminSketchOrderClient extends RoofSnapApiClient {
    async getSketchOrders(params) {
        const { queryParams } = params;
        const url = `${baseUrl}${queryParams}`;

        const sketchOrders = await super.get(url);
        return sketchOrders;
    }

    async getSketchOrder(params) {
        const { id } = params;
        const url = `${baseUrl}/${id}`;
        const sketchOrder = await super.get(url);
        return sketchOrder;
    }

    async updateSketchOrder(params) {
        const { id, body, version } = params;
        const url = `${baseUrl}/${id}`;
        const sketchOrder = await super.update(url, body, version);
        return sketchOrder;
    }

    async createNotification(params) {
        const { sketchOrderId, body } = params;
        const url = `${baseUrl}/${sketchOrderId}/notifications`;
        return await super.create(url, body);
    }

    async updateNotification(params) {
        const { sketchOrderId, id, body, version } = params;
        const url = `${baseUrl}/${sketchOrderId}/notifications/${id}`;
        return await super.update(url, body, version);
    }

    async deleteNotification(params) {
        const { sketchOrderId, id } = params;
        const url = `${baseUrl}/${sketchOrderId}/notifications/${id}`;
        return await super.delete(url);
    }

    async getNotifications(params) {
        const { sketchOrderId } = params;
        const url = `${baseUrl}/${sketchOrderId}/notifications`;
        return await super.get(url);
    }

    async deleteSketchOrderProject(params) {
        const { id } = params;
        const url = `${baseUrl}/${id}/project`;
        return await super.delete(url);
    }
}

export default SketchAdminSketchOrderClient;
